import { OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Menu } from '../../shared/menu/menu.model';
import { FullMenuService } from '../full-menu.service';
var FullMenuOrderComponent = /** @class */ (function () {
    function FullMenuOrderComponent(translate, route, fullMenuService) {
        this.translate = translate;
        this.route = route;
        this.fullMenuService = fullMenuService;
        this.newMenu = new EventEmitter();
    }
    FullMenuOrderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.selectedSort = 'views';
        this.fullMenuService.getSortType().subscribe(function (sortType) {
            _this.selectedSort = sortType;
        });
    };
    FullMenuOrderComponent.prototype.ngOnChanges = function () {
        if (this.menu && !this.isOrder) {
            this.isOrder = true;
        }
    };
    FullMenuOrderComponent.prototype.sortMenuBy = function (sortType) {
        this.fullMenuService.setSortType(sortType);
    };
    return FullMenuOrderComponent;
}());
export { FullMenuOrderComponent };
